var swiper = new Swiper(".swiper.is-product-tab", {
  slidesPerView: 4,
  navigation: {
    nextEl: ".arrow-block.is-next",
    prevEl: ".arrow-block.is-prev",
  },
  breakpoints: {
    320: { slidesPerView: 1 },
    480: { slidesPerView: 1 },
    640: { slidesPerView: 1 },
    768: { slidesPerView: 2 },
    992: { slidesPerView: 3 },
  },
});



$('.product-card__title, .recommendation-class .product-card__title').each(function() {
  const fullTitle = $(this).text().trim();
  const maxLength = 45;
  if (fullTitle.length > maxLength) {
    $(this).text(fullTitle.slice(0, maxLength) + '...');
  }
});

$(document).ready(function() {
    var firstAccordion = $('.product__accordion.details:first');
    firstAccordion.prop('open', true);
    firstAccordion.attr('aria-expanded', 'true');

    firstAccordion.on('toggle', function() {
      if (firstAccordion.prop('open')) {
        firstAccordion.attr('aria-expanded', 'true'); 
      } else {
        firstAccordion.attr('aria-expanded', 'false');
      }
    });
});

document.addEventListener("DOMContentLoaded", function () {
  var readMoreLink = document.querySelector(".read-more");
  var fullDescription = document.querySelector(".description-full");
  var excerpt = document.querySelector(".description-excerpt");

  if (readMoreLink && fullDescription && excerpt) {
    readMoreLink.addEventListener("click", function (event) {
      event.preventDefault();
      if (fullDescription.style.display === "none") {
        fullDescription.style.display = "inline";
        excerpt.style.display = "none";
        readMoreLink.textContent = "Read Less";
      } else {
        fullDescription.style.display = "none";
        excerpt.style.display = "inline";
        readMoreLink.textContent = "Read More";
      }
    });
  }
});

$('.product-video').click(function(){
  $('.products-video-wrapper').show();
});

$('.close-icon').click(function(){
  $('.products-video-wrapper').hide();
});